/**
 * All the keys we use in the HTML5 SessionStorage.
 */
export enum HisSessionStorageKeys {
    // cs.sys
    CS_SYS_LAST_USERNAME = 'his_cs_sys_lastUsername',
    CS_SYS_LAST_MENU_ITEM = 'his_cs_sys_last_menu_item',
    CS_SYS_LAST_SEARCH_URL = 'his_cs_sys_last_search_url',
    CS_SYS_LAST_SEARCHRESULT_URL = 'his_cs_sys_last_searchresult_url',
    CS_SYS_SEARCH_CRITERIA_SET_COMPONENT_ID = 'his_cs_sys_search_criteria_set_component_id',
    CS_SYS_LAST_SEARCH_BUTTON = 'his_cs_sys_last_search_button',
    CS_SYS_LAST_SEARCH_CRITERIA_SET = 'his_cs_sys_last_search_criteria_set',
    CS_SYS_LAST_RESULT_CONFIG_FILES = 'his_cs_sys_last_result_config_files',
    CS_SYS_ANONYMOUS_PAGE_SIZE = 'his_cs_sys_anonymous_page_size',
    CS_SYS_ANONYMOUS_DEFAULT_TABLE_PAGE_SIZE = 'his_cs_sys_anonymous_default_table_page_size',
    CS_SYS_ANONYMOUS_HIDDEN_COLS = 'his_cs_sys_anonymous_hidden_cols',
    CS_SYS_ANONYMOUS_PAGINATOR_POSITION = 'his_cs_sys_anonymous_paginator_position',
    CS_SYS_ANONYMOUS_SHOW_TABLE_FILTER = 'his_cs_sys_anonymous_show_table_filter',
    CS_SYS_ANONYMOUS_FROZEN_COL = 'his_cs_sys_anonymous_frozen_col',
    CS_SYS_ANONYMOUS_COL_ORDER = 'his_cs_sys_anonymous_col_order',
    CS_SYS_LAST_BACK_URL = 'his_cs_sys_last_back_url',
    CS_SYS_SORT_LAST_COLUMN_SORTORDER = 'his_cs_sys_last_column_sortorder',
    // fs.res
    // cs.bia
    // etc.
}
